export default "__VITE_ASSET__BzuKlh9e__"